// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filteredSearchFieldsStyle } from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/ListPages/FilteredSearchFieldsStyle";
import { filterHeaderStyle } from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/ListPages/FilterHeaderStyle";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import { rfqMyQuotesFilterStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesFilter";
import { css } from "styled-components";

rfqMyQuotesFilterStyles.container = filteredSearchFieldsStyle.containerWithPadding;

rfqMyQuotesFilterStyles.clearFiltersButton = filterHeaderStyle.clearFiltersButton;

rfqMyQuotesFilterStyles.headingItem = filterHeaderStyle.headingItem;

rfqMyQuotesFilterStyles.fromGridItem = rfqMyQuotesFilterStyles.toGridItem = rfqMyQuotesFilterStyles.expireFromGridItem = rfqMyQuotesFilterStyles.expireToGridItem = {
    width: [12, 6, 6, 3, 3],
    css: css`
        & > div {
            flex-grow: 1;
        }
    `,
};

rfqMyQuotesFilterStyles.customerGridItem = rfqMyQuotesFilterStyles.quoteNumberGridItem = rfqMyQuotesFilterStyles.userGridItem = rfqMyQuotesFilterStyles.salesRepGridItem = {
    width: [12, 12, 6, 6, 3],
};

rfqMyQuotesFilterStyles.appliedFiltersContainer = {
    css: css`
        ${rfqMyQuotesFilterStyles.appliedFiltersContainer?.css}
        ${filterHeaderStyle.appliedFiltersContainer?.css}
        ${xScreen.lte("xs")} {
            width: 100%;
            div[class^="TagWrapper"] {
                margin-right: 0;
                width: 100%;
            }
            div[class^="TagStyle"] {
                width: 100%;
                max-width: none;
            }
        }
    `,
};
